module.exports = __webpack_public_path__ + "files/a2f4638a1a752082d235f03ed247f0a5.png";